// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DuRdP","footer":"styles_footer__20Ke9"};